import React from 'react';
import {SectionMain, Tabs, Tab, FormDialog} from 'components/core';
import Singletons from 'controllers/Singletons';
import {TemplatesCtxProvider} from 'components/dataProviders/procedureTemplates';
import TemplatePanel from './main/panel';
import TemplatesMain from './main/index';
import {TemplateFieldsCtxProvider} from 'components/dataProviders/procedureTemplateFields';

export default function ProceduresWrapper()
{
  return <TemplatesCtxProvider><Templates></Templates></TemplatesCtxProvider>
}


function Templates()
{
    const [panelState, setPanelState] = React.useState({show: false, props: {}});
    const [createDialogOpen, setCreateDialogOpen] = React.useState(false);
    const [loadedTemplate, setLoadedTemplate] = React.useState(null);

    const editable = Singletons.currentUser.profiles.indexOf("experts") > -1 || Singletons.currentUser.profiles.indexOf("administrators") > -1;

    const handleNewButtonClick = () =>
    {
      setCreateDialogOpen(true);
    }

    const handleClosePanel = () =>
    {
        setPanelState({show: false, props: {}});
    }

    const handleShowPanel = (panelProps) =>
    {
      setLoadedTemplate(panelProps.templateID);
      setPanelState({show: true, props: panelProps});
    }

    const panel = <TemplatePanel {...panelState.props} onClose={() => handleClosePanel()} editable={editable}/>;

    

    return <TemplateFieldsCtxProvider templateID={loadedTemplate}>
        <SectionMain title="Plantillas de Procedimientos" buttonLabel="Crear Plantilla" showDetail={panelState.show} onButtonClick={() => handleNewButtonClick()} detail = {panel} buttonHidden={!editable}>
          <TemplatesMain mainDialogOpen={createDialogOpen} onDialogClose={()=>setCreateDialogOpen(false)} collapsed = {panelState.show} handleShowPanel={(props) => handleShowPanel(props)}/>
        </SectionMain>
    </TemplateFieldsCtxProvider>
}

